module.exports = __webpack_public_path__ + "media/images/page/photo_large-b3c6428f224be7ca1083a8877e2f98c4.jpg";